import React from 'react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Sidebar } from './Sidebar/Sidebar'
import { Brand, Category, Size } from '@/api'

interface FilterSheetProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onClear: () => void
  onApply: () => void
  brand?: Brand
  categories: Category[]
  sizes?: Size[]
  selectedGender: string
  selectedCategories: string[]
  selectedConditions: string[]
  selectedSizes: string[]
  keyword?: string
  onGenderChange: (gender: string) => void
  onCategoryChange: (categories: string[]) => void
  onConditionChange: (conditions: string[]) => void
  onSizeChange: (sizes: string[]) => void
  onKeywordChange?: (keyword: string) => void
}

export const FilterSheet: React.FC<FilterSheetProps> = ({
  isOpen,
  onOpenChange,
  onClear,
  onApply,
  brand,
  categories,
  sizes,
  selectedGender,
  selectedCategories,
  selectedConditions,
  selectedSizes,
  keyword,
  onGenderChange,
  onCategoryChange,
  onConditionChange,
  onSizeChange,
  onKeywordChange,
}) => {
  const handleApplyAndClose = () => {
    onApply()
    onOpenChange(false)
  }

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-full sm:w-[380px] p-0">
        <SheetHeader className="px-4 py-3 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <SheetTitle className="text-[15px] font-semibold">
              Filter -
            </SheetTitle>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onOpenChange(false)}
              className="h-8 w-8 -mr-2"
            ></Button>
          </div>
        </SheetHeader>
        <div className="overflow-y-auto h-[calc(100vh-120px)]">
          <Sidebar
            brand={brand || undefined}
            categories={categories || undefined}
            sizes={sizes || undefined}
            selectedGender={selectedGender}
            selectedCategories={selectedCategories}
            selectedConditions={selectedConditions}
            selectedSizes={selectedSizes}
            keyword={keyword}
            onGenderChange={onGenderChange}
            onCategoryChange={onCategoryChange}
            onConditionChange={onConditionChange}
            onSizeChange={onSizeChange}
            onKeywordChange={onKeywordChange}
          />
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gray-100 p-4">
          <div className="flex gap-4 justify-center">
            <Button
              variant="outline"
              onClick={onClear}
              className="font-bold h-12 w-[110px] bg-white border-gray-300 text-black hover:bg-gray-50 rounded-none text-[14px] border-0"
            >
              クリア
            </Button>
            <Button
              onClick={handleApplyAndClose}
              className="font-bold h-12 w-[110px] bg-black text-white hover:bg-gray-800 rounded-none text-[14px] border-0"
            >
              確定
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}
